import { getProductConfig } from "@/config/product.config";
import type { ProductConfig } from "@/config/product.config";

/**
 * Hook to access current product configuration
 *
 * Usage:
 * const { i18n, isInterview } = useProduct();
 * <h1>{i18n.welcomeMessage}</h1>
 */
export const useProduct = (): ProductConfig & {
  isInterview: boolean;
  isMeetings: boolean;
} => {
  const config = getProductConfig();

  return {
    ...config,
    isInterview: config.id === "interview",
    isMeetings: config.id === "meetings",
  };
};
